<template>
  <div>
    <GmapMap :center="{ lat: -6.882475243436495, lng: -79.21514769772674 }" :zoom="10"
      style="width: 100%; height: 95vh" @click="addVertex" @mousemove="updateTempVertex" ref="mapRef">
      <GmapInfoWindow v-if="infoWindowOpened" :position="infoWindowPosition" @closeclick="infoWindowOpened = false">
        <div>
          <div class="info-window-content" v-html="infoWindowContent"></div>
        </div>
      </GmapInfoWindow>
      <GmapMarker :key="'clinica-' + index" v-for="(marker, index) in arrayClinicasMapa"
        :position="{ lat: parseFloat(marker.latitud), lng: parseFloat(marker.longitud) }" v-if="zonaOptions[5].state"
        @click="showInfoWindowClinica(marker, index)" :clickable="true" :draggable="false"
        :icon="getMarkerOptionsClinica(marker.name)" />
      <GmapInfoWindow v-if="infoWindowOpenedClinica" :position="infoWindowPositionClinica"
        @closeclick="infoWindowOpenedClinica = false">
        <div class="info-window-content" v-html="infoWindowContentClinica"></div>
      </GmapInfoWindow>
      <GmapMarker :key="'clinicaOpa-' + index" v-for="(marker, index) in arrayDataClinicaTotal"
        v-if="zonaOptions[6].state" :position="{ lat: parseFloat(marker.latitud), lng: parseFloat(marker.longitud) }"
        @click="showInfoWindowClinicaOpa(marker, index)" :draggable="false" :icon="{
          url: require('@/assets/icono clinica2 opa.png'),
          scaledSize: { width: 20, height: 20, f: 'px', b: 'px', },
          opacity: 0.1
        }" />
      <div v-if="!isClosed">
        <GmapPolyline v-for="(cord, index) in polygonCoordsStatic" :key="'coord-' + index" :path="[cord.a, cord.b]"
          :options="{
            strokeColor: '#ff0000',
            strokeOpacity: 0.7,
            strokeWeight: 1
          }" />
      </div>
      <!-- Línea indicadora -->
      <GmapPolyline v-if="tempVertex && polygonCoords.length > 0 && !isClosed" @click="addVertex" :options="{
        path: [polygonCoords[polygonCoords.length - 1], tempVertex],
        strokeColor: '#ff0000',
        strokeOpacity: 0.5,
        strokeWeight: 1,
      }" />
      <div v-for="(group, groupIndex) in markerGroups" :key="groupIndex" v-if="zonaOptions[7].state">
        <GmapMarker :key="'prueba-' + index" v-for="(marker, index) in group.items"
          :position="{ lat: parseFloat(marker.latitud), lng: parseFloat(marker.longitud) }" :clickable="true"
          v-if="marker.state" :draggable="false" :icon="getMarkerOptions(marker.descripcas)"
          @click="showInfoWindow(marker, index)" />
      </div>
      <GmapMarker :key="'marcadores-' + index" v-for="(marker, index) in groupMarcadores"
        :position="{ lat: parseFloat(marker.latitud), lng: parseFloat(marker.longitud) }" :clickable="true"
        :draggable="true" @dragend="updateMarkerPosition($event, index)" />
      <GmapPolygon v-for="(polygon, index) in polygonsCallao" :key="'callao-' + index" :paths="polygon.paths"
        :options="polygonOptionsLimaCallao" v-if="zonaOptions[0].state" />
      <GmapPolygon v-for="(polygon, index) in polygonsLimaNorte" :key="'ln-' + index" :paths="polygon.paths"
        :options="polygonOptionsLimaNorte" v-if="zonaOptions[2].state" />

      <GmapPolygon v-for="(polygon, index) in polygonsLimaEste" :key="'le-' + index" :paths="polygon.paths"
        :options="polygonOptionsLimaEste" v-if="zonaOptions[1].state" />
      <GmapPolygon v-for="(polygon, index) in polygonsLimaSur" :key="'ls-' + index" :paths="polygon.paths"
        :options="polygonOptionsLimaSur" v-if="zonaOptions[3].state" />
      <GmapPolygon v-for="(polygon, index) in polygonsLimaCentro" :key="'lc-' + index" :paths="polygon.paths"
        :options="polygonOptionsCentro" v-if="zonaOptions[4].state" />
      <GmapPolygon v-if="statusSelect" :paths="polygonCoords" :editable="true" @paths_changed="onPolygonPathsChanged1"
        :draggable="true" :options="polygonOptions" />
    </GmapMap>
    <!-- Control personalizado -->
    <div class="container-options-map" ref="customControl">
      <!-- Menú de selección de color -->
      <v-menu :close-on-content-click="false" top :offset-y="offset">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" style="margin: 0 .2rem;">
            <v-icon>mdi mdi-palette</v-icon>
          </v-btn>
        </template>
        <div style="position: relative; height: 15rem; display: flex;overflow: hidden;">
          <v-list style=" margin-right: 20rem; background: transparent;overflow: none;">
            <v-card
              style="bottom: 0; margin-top: auto; width: 21rem;height: 15rem;overflow-x: hidden;overflow-y: scroll;align-items: end;">
              <v-list-item v-for="(item, index) in arrayClinicasMapa" :key="index"
                style="display: flex;width: 20rem !important;">
                <v-list-item-title
                  style="display: flex; justify-content: space-between; align-items: center; font-size:.6rem ;width: 20rem !important; min-height: 30px  !important;">
                  {{ item.name.length > 47 ? item.name.slice(0, 47) + '...' : item.name }}
                  <div>
                    <v-icon style="cursor: pointer; margin-left: .4rem;font-size: 1rem;"
                      @click="toggleColorPicker(item, $event)">
                      mdi-format-color-fill
                    </v-icon>
                   <!--  <v-icon style="font-size: .7rem;" :color="markerGroups[item.name].color">mdi-circle</v-icon> -->
                   <span 
                    style="display: inline-block; width: 0.7rem; height: 0.7rem; border-radius: 50%;"
                    :style="{ backgroundColor: markerGroups[item.name].color }">
                  </span>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-card>
          </v-list>
          <!-- Picker de color flotante -->
          <div v-if="isColorPickerVisible && selectedItem" class="color-picker-container" ref="colorPicker"
            id="colorPicker" :style="{ position: 'absolute', left: 400 + 'px', top: colorPickerPosition.top + 'px' }">
            <chrome-picker v-model="selectedColor" :value="colors"/>
          </div>
        </div>
      </v-menu>

      <v-menu :close-on-content-click="false" top :offset-y="offset">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" style="margin: 0 .2rem;">
            <v-icon>mdi mdi-eye-outline</v-icon>
          </v-btn>
        </template>
        <v-list style=" margin-right: 20rem; background: transparent;overflow: none;">
          <v-card
            style="bottom: 0; margin-top: auto; width: 11rem;height: 15rem;overflow-x: hidden;overflow-y: scroll;align-items: end;">
            <v-list-item v-for="(item, index) in zonaOptions" :key="index"
              style="display: flex;width: 10rem !important;">
              <v-list-item-title
                style="display: flex; justify-content: space-between; align-items: center; font-size:.6rem ;width: 20rem !important; min-height: 30px  !important;">
                {{ item.name }}
                <div>
                  <v-icon style="cursor: pointer; margin-left: .4rem;font-size: 1rem;"
                    @click="updetaZonaView(item, index)" v-if="!item.state">
                    mdi mdi-eye-off-outline
                  </v-icon>
                  <v-icon style="cursor: pointer; margin-left: .4rem;font-size: 1rem;"
                    @click="updetaZonaView(item, index)" v-if="item.state">
                    mdi mdi-eye-outline
                  </v-icon>
                </div>
              </v-list-item-title>
            </v-list-item>
          </v-card>
        </v-list>
      </v-menu>
      <v-btn style="margin: 0 .2rem;" @click="stateSelectOpen" v-if="isClosed && !stateSelectView">
        <v-icon>mdi mdi-select-drag</v-icon>
      </v-btn>
      <v-btn style="margin: 0 .2rem;" @click="stateSelectRemove" v-if="isClosed && stateSelectView">
        <v-icon>mdi mdi-close-box</v-icon>
      </v-btn>
      <v-menu :close-on-content-click="false" top :offset-y="offset">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" style="margin: 0 .2rem;">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </template>
        <v-list style=" margin-right: 20rem; background: transparent;overflow: none;">
          <v-card
            style="bottom: 0; margin-top: auto; width: 21rem;height: 15rem;overflow-x: hidden;overflow-y: scroll;align-items: end;">
            <v-list-item v-for="(item, index) in arrayClinicasMapa" :key="index"
              style="display: flex;width: 20rem !important;">
              <v-list-item-title
                style="display: flex; justify-content: space-between; align-items: center; font-size:.6rem ;width: 20rem !important; min-height: 30px  !important;">
                {{ item.name }}
                <div>
                  <v-menu :close-on-content-click="false" top :offset-y="offset">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon style="font-size: 1rem;" v-bind="attrs" v-on="on">mdi-filter-variant</v-icon>
                    </template>
                    <v-list style=" margin-right: 2rem; background: transparent;overflow: none;">
                      <v-card
                        style="bottom: 0; margin-top: auto; width: 12rem;height: 9rem;overflow-x: hidden;overflow-y: scroll;align-items: end;">
                        <v-list-item v-for="(itemFilter, index) in item.groupFilter" :key="index"
                          style="display: flex;width: 8rem !important;">
                          <v-list-item-title
                            style="display: flex;  align-items: center; font-size:.6rem ;width: 8rem !important; min-height: 30px  !important;">
                            <input type="checkbox" :value="itemFilter.name" v-model="itemFilter.state"
                              @change="updatePaciente(itemFilter, item.name)" />
                            {{ itemFilter.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-card>
                    </v-list>
                  </v-menu>
                </div>
              </v-list-item-title>
            </v-list-item>
          </v-card>
        </v-list>
      </v-menu>
      <v-menu :close-on-content-click="false" top :offset-y="offset">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" style="margin: 0 .2rem;">
            <v-icon>mdi-account-multiple</v-icon>
          </v-btn>
        </template>
        <v-list style=" margin-right: 20rem; background: transparent;overflow: none;">
          <v-card
            style="bottom: 0; margin-top: auto; width: 6rem;align-items: end;background: transparent;box-shadow: none;">
            <v-btn style="margin: .2rem 0;" @click="addMarcador">
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
            <v-btn style="margin: .2rem 0;" @click="menusMarcador">
              <v-icon>mdi-account-minus</v-icon>
            </v-btn>
          </v-card>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<style scope>
.v-list-item {
  min-height: 18px !important;
}

.v-menu__content {
  box-shadow: none !important;
}

.color-poligono {
  color: red !important;
  background: red !important;
}

/* Estilo para el contenido de la ventana de información */
.info-window-content {
  font-size: .6rem;
  font-size: .8rem;
  width: 100%;
  max-width: 160px !important;
  margin-bottom: .3rem;
}

.gm-ui-hover-effect {
  width: 32px !important;
  /* Ancho de la ventana */
  height: 13px !important;
}

.gm-ui-hover-effect span {
  width: 12px !important;
  /* Ancho de la ventana */
  height: 12px !important;
  margin: .3rem auto !important;
}

/* Estilo global para el botón de cerrar */
::v-deep .gm-style-iw {
  .gm-style-iw+div {
    top: 10px;
    /* Ajusta la posición superior del botón */
    right: 10px;
    /* Ajusta la posición derecha del botón */
    width: 20px;
    /* Ancho del botón de cerrar */
    height: 20px;
    /* Alto del botón de cerrar */
  }
}

.text-content {
  letter-spacing: .6px;
}

.text-negra {
  font-weight: 600 !important;
  font-size: .7rem;
}

.container-options-map {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
}

.color-picker-container {
  position: absolute;
  z-index: 1001;
}

.my-svg {
  width: 100px !important;
  /* o el tamaño que desees */
  height: 100px !important;
}
</style>
<script>
import { Chrome } from 'vue-color';
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import { mapGetters, mapActions } from 'vuex';
import { gmapApi, GmapMapa } from 'vue2-google-maps';
import { mi_peru } from '../coordenadas/callao/mi_peru';
import { bellavista } from '../coordenadas/callao/bellavista';
import { ventanilla } from '../coordenadas/callao/ventanilla';
import { callao } from '../coordenadas/callao/callao';
import { carmen_legua } from '../coordenadas/callao/carmen_legua';
import { la_perla } from '../coordenadas/callao/la_perla';
import { la_punta } from '../coordenadas/callao/la_punta';
import { ancon } from '../coordenadas/lima_norte/ancon';
import { carabayllo } from '../coordenadas/lima_norte/carabayllo';
import { comas } from '../coordenadas/lima_norte/comas';
import { independencia } from '../coordenadas/lima_norte/independencia';
import { los_olivos } from '../coordenadas/lima_norte/los_olivos';
import { puente_piedra } from '../coordenadas/lima_norte/puente_piedra';
import { san_martin_porres } from '../coordenadas/lima_norte/san_martin_porres';
import { santa_rosa } from '../coordenadas/lima_norte/santa_rosa';
import { ate } from '../coordenadas/lima_este/ate';
import { chaclacayo } from '../coordenadas/lima_este/chaclacayo';
import { cieneguilla } from '../coordenadas/lima_este/cieneguilla';
import { el_agustino } from '../coordenadas/lima_este/el_agustino';
import { la_molina } from '../coordenadas/lima_este/la_molina';
import { lurigancho } from '../coordenadas/lima_este/lurigancho';
import { san_luis } from '../coordenadas/lima_este/san_luis';
import { san_lurigancho } from '../coordenadas/lima_este/san_lurigancho';
import { santa_anita } from '../coordenadas/lima_este/santa_anita';
import { chorrillos } from '../coordenadas/lima_sur/chorrillos';
import { lurin } from '../coordenadas/lima_sur/lurin';
import { pachacamac } from '../coordenadas/lima_sur/pachacamac';
import { pucusana } from '../coordenadas/lima_sur/pucusana';
import { punta_hermosa } from '../coordenadas/lima_sur/punta_hermosa';
import { punta_negra } from '../coordenadas/lima_sur/punta_negra';
import { san_bartolo } from '../coordenadas/lima_sur/san_bartolo';
import { san_juan_miraflores } from '../coordenadas/lima_sur/san_juan_miraflores';
import { santa_maria_mar } from '../coordenadas/lima_sur/santa_maria_mar';
import { villa_maria_triunfo } from '../coordenadas/lima_sur/villa_maria_triunfo';
import { villa_salvador } from '../coordenadas/lima_sur/villa_salvador';
import { barranco } from '../coordenadas/lima_centro/barranco';
import { brena } from '../coordenadas/lima_centro/brena';
import { jesus_maria } from '../coordenadas/lima_centro/jesus_maria';
import { la_victoria } from '../coordenadas/lima_centro/la_victoria';
import { lima } from '../coordenadas/lima_centro/lima';
import { lince } from '../coordenadas/lima_centro/lince';
import { magdalena_mar } from '../coordenadas/lima_centro/magdalena_mar';
import { miraflores } from '../coordenadas/lima_centro/miraflores';
import { pueblo_libre } from '../coordenadas/lima_centro/pueblo_libre';
import { rimac } from '../coordenadas/lima_centro/rimac';
import { san_borja } from '../coordenadas/lima_centro/san_borja';
import { san_isidro } from '../coordenadas/lima_centro/san_isidro';
import { san_miguel } from '../coordenadas/lima_centro/san_miguel';
import { santiago_surco } from '../coordenadas/lima_centro/santiago_surco';
import { surquillo } from '../coordenadas/lima_centro/surquillo';
import { mapState } from "vuex";
export default {
  props: ['dataPaciente'],
  data() {
    return {
      isClosed: true,
      stateDraw: false,
      zonaOptions: [
        { name: "Lima callao", state: true },
        { name: "Lima este", state: true },
        { name: "Lima norte", state: true },
        { name: "Lima sur", state: true },
        { name: "Lima centro", state: true },
        { name: "Clínica", state: true },
        { name: "Clínicas Totales", state: true },
        { name: "Pacientes", state: true }
      ],
      offset: true,
      polygonOptionsLimaCallao: {
        fillColor: "#02abd9",
        fillOpacity: 0.1,
        strokeColor: "#02abd9",
        strokeOpacity: 0.8,
        strokeWeight: 0.5
      },
      polygonOptionsLimaNorte: {
        fillColor: "#c6cc03 ",
        fillOpacity: 0.1,
        strokeColor: "#c6cc03 ",
        strokeOpacity: 0.8,
        strokeWeight: 0.5
      },
      polygonOptionsLimaEste: {
        fillColor: "#7e00ad",
        fillOpacity: 0.1,
        strokeColor: "#7e00ad",
        strokeOpacity: 0.8,
        strokeWeight: 0.5
      },
      polygonOptionsLimaSur: {
        fillColor: "#00b548",
        fillOpacity: 0.1,
        strokeColor: "#00b548",
        strokeOpacity: 0.8,
        strokeWeight: 0.5
      },
      polygonOptionsCentro: {
        fillColor: "#FF0000",
        fillOpacity: 0.1,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 0.5
      },
      polygonOptions: {
        fillColor: "#FF0000",
        fillOpacity: 0.35,
        strokeColor: "#0000FF",
        strokeOpacity: 1,
        strokeWeight: 2
      },
      selectedColor: { hex: '#6a0dad', a: 1 },
      markerGroups: [
        {
          name: 'Group 1',
          positions: [
            { lat: -12.0464, lng: -77.0428 },
            { lat: -12.0470, lng: -77.0435 },
          ],
          color: '#FF5733' // Color inicial del grupo
        },
        {
          name: 'Group 2',
          positions: [
            { lat: -12.0450, lng: -77.0410 },
            { lat: -12.0460, lng: -77.0440 },
          ],
          color: '#33FF57' // Color inicial del grupo
        }
      ],
      infoWindowOpened: false,
      infoWindowPosition: null,
      infoWindowContent: '',
      infoWindowOpenedClinica: false,
      infoWindowPositionClinica: null,
      infoWindowContentClinica: '',
      statusSelected: false,
      drawingManager: null,
      polygonsCallao: [
        { paths: mi_peru },
        { paths: ventanilla },
        { paths: la_perla },
        { paths: carmen_legua },
        { paths: callao },
        { paths: bellavista },
        { paths: la_punta }
      ],
      polygonsLimaNorte: [
        { paths: ancon },
        { paths: carabayllo },
        { paths: comas },
        { paths: independencia },
        { paths: los_olivos },
        { paths: puente_piedra },
        { paths: san_martin_porres },
        { paths: santa_rosa }
      ],
      polygonsLimaEste: [
        { paths: ate },
        { paths: chaclacayo },
        { paths: cieneguilla },
        { paths: el_agustino },
        { paths: la_molina },
        { paths: lurigancho },
        { paths: san_luis },
        { paths: san_lurigancho },
        { paths: santa_anita }
      ],
      polygonsLimaSur: [
        { paths: chorrillos },
        { paths: lurin },
        { paths: pachacamac },
        { paths: pucusana },
        { paths: punta_hermosa },
        { paths: punta_negra },
        { paths: san_bartolo },
        { paths: san_juan_miraflores },
        { paths: santa_maria_mar },
        { paths: villa_maria_triunfo },
        { paths: villa_salvador }
      ],
      polygonsLimaCentro: [
        { paths: barranco },
        { paths: brena },
        { paths: jesus_maria },
        { paths: la_victoria },
        { paths: lima },
        { paths: lince },
        { paths: magdalena_mar },
        { paths: miraflores },
        { paths: pueblo_libre },
        { paths: rimac },
        { paths: san_borja },
        { paths: san_isidro },
        { paths: san_miguel },
        { paths: santiago_surco },
        { paths: surquillo }
      ],
      polygonOptionsPrueba: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35
      },
      polygonsPrueba: [],
      polygonOptions: {
        strokeColor: '#eb4034', // Color del borde
        strokeOpacity: 0.8,     // Opacidad del borde
        strokeWeight: 0.1,        // Grosor del borde
        fillColor: '#eb4034',   // Color de relleno
        fillOpacity: 0.35       // Opacidad de relleno
      },
      polygonOptionsLN: {
        strokeColor: '#eb4034', // Color del borde
        strokeOpacity: 0.1,     // Opacidad del borde
        strokeWeight: 0.1,        // Grosor del borde
        fillColor: '#eb4034',   // Color de relleno
        fillOpacity: 0.35       // Opacidad de relleno
      },
      marcadores: [
        {
          lat: -12.074928851253814, lng: -77.04316187097396
        }
      ],
      markers: [
        { id: 1, lat: -12.074928851253814, lng: -77.04316187097396 }, // Ejemplo de marcadores con coordenadas
      ],
      marcadoresPoligono: 0,
      listPath: [],
      isMenuOpenColor: false,
      isMenuOpenSelector: false,
      isColorPickerVisible: false,
      selectedItem: null,// Color por defecto
      colorPickerPosition: { left: 0, top: 0 },
      /* markerGroups: [{ color: '#ff0000' }, { color: '#00ff00' }], */
      items: [{ title: 'Item 1' }, { title: 'Item 2' }],
      selectedGroupIndex: '',
      selectedGroupIndex: null,
      // Array de grupos de marcadores
      markerGroups: [],
      arrayClinicas: [],
      arrayClinicasMapa: [],
      polygonCoordsStatic: [],
      polygonCoords: [],
      statusSelect: false,
      tempVertex: null,
      stateSelectView: false,
      groupFilter: [
        { name: "LUN-MIE-VIE", state: true },
        { name: "MAR-JUE-SAB", state: true },
        { name: "LUN-VIE", state: true },
        { name: "MAR-SAB", state: true },
      ],
      isFilterVisible: true,
      arrayFrecuenciaClinica: [],
      markerGroupsPermanente: [],
      groupMarcadores: [],
      colors:'#194D33'
    };

  },

  methods: {
    // Método para actualizar la posición del marcador
    updateMarkerPosition(event, index) {
      const { lat, lng } = event.latLng.toJSON(); // Obtener latitud y longitud del evento
      this.groupMarcadores[index].latitud = lat;
      this.groupMarcadores[index].longitud = lng;
    },
    addMarcador() {
      const nuevoMarcador = {
        latitud: -12.0450, // Define la latitud deseada
        longitud: -77.0440, // Define la longitud deseada
        descripcas: `Marcador ${this.groupMarcadores.length + 1}`,
      };
      this.groupMarcadores.push(nuevoMarcador); // Agregar a la lista
    },
    menusMarcador() {
      if (this.groupMarcadores.length > 0) {
        this.groupMarcadores.pop(); // Eliminar el último elemento
      } else {
        alert("No hay marcadores para eliminar");
      }
    },
    updatePaciente(itemFilter, name) {
      const frecuenciaFiltrada = itemFilter.name;// Puedes cambiar este valor dinámicamente
      let datosPermanente = this.markerGroups;
      let filteredItems = [];

      Object.keys(datosPermanente[name]).forEach(key => {
        const clinica = JSON.parse(JSON.stringify(datosPermanente[name])); // Crear una copia profunda de la clínica actual

        // Filtrar los items por frecuencia y modificar el estado de los items que cumplen con la frecuencia
        const itemsFiltrados = clinica.items.map(item => {
          if (item.frecuencia === frecuenciaFiltrada) {
            item.state = itemFilter.state;  // Modificar el estado del item si cumple con la frecuencia
          }
          return item;  // Devuelve el item con el estado modificado (o no modificado si no cumple la frecuencia)
        });

        // Agregar el resultado al arreglo filteredItems
        filteredItems.push({
          ...clinica,  // Mantener los otros datos de la clínica
          items: itemsFiltrados // Los items con el estado actualizado
        });
      });
      delete this.markerGroups[name];
      this.markerGroups[name] = filteredItems[0];
      if (this.isClosed && this.stateSelectView) {
        const polygon = new google.maps.Polygon({
          paths: this.polygonCoords.map(point => ({ lat: point.lat, lng: point.lng })),
        });
        let arrayTotal = [];
        Object.entries(this.markerGroups).forEach(([clinicName, clinicData]) => {
          // Filtrar los marcadores dentro del polígono y con state = true
          const markersInsidePolygon = clinicData.items.filter(marker => {
            const markerPosition = new google.maps.LatLng(marker.latitud, marker.longitud);

            // Verificar si el marcador está dentro del polígono y su estado es true
            return google.maps.geometry.poly.containsLocation(markerPosition, polygon) && marker.state === true;
          });
          console.log("array datos", markersInsidePolygon);
          // Llamar a la función guardarDatos con los marcadores dentro del polígono y con state = true
          arrayTotal = [...arrayTotal, ...markersInsidePolygon];
        });
        this.guardarDatos(arrayTotal);
      }

    },
    // Activar cursor personalizado
    setCustomCursor() {
      const pencilSVG = `
        data:image/svg+xml;charset=UTF-8,
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2l6 6-10 10-6-6z"></path>
          <path d="M2 22l4-4"></path>
        </svg>
      `;
      const map = this.$refs.mapRef.$mapObject; // Obtener instancia del mapa
      map.setOptions({
        draggableCursor: `url(${pencilSVG}) 0 24, auto`, // Cambia el cursor cuando el mouse está sobre el mapa
      });
    },
    resetCursor() {
      document.body.style.cursor = 'default';
    },
    stateSelectOpen() {
      this.setCustomCursor();
      this.isClosed = false;
      this.zonaOptions[0].state = false;
      this.zonaOptions[1].state = false;
      this.zonaOptions[2].state = false;
      this.zonaOptions[3].state = false;
      this.zonaOptions[4].state = false;
    },
    stateSelectRemove() {
      this.stateSelectView = false;
      this.isClosed = true;
      this.tempVertex = null;
      this.polygonCoords = [];
      this.guardarDatos([]);
    },
    updateTempVertex(event) {
      this.tempVertex = event.latLng;
    },
    addVertex(event) {
      if (this.isClosed) {
        return;
      }
      const latLng = event.latLng;
      if (this.polygonCoords.length > 0) {
        this.polygonCoordsStatic.push({ "a": this.polygonCoords[this.polygonCoords.length - 1], "b": { lat: latLng.lat(), lng: latLng.lng() } });
      }
      // Agregar las coordenadas del polígono
      this.polygonCoords.push({ lat: latLng.lat(), lng: latLng.lng() });
      // Cerrar el polígono si se hace clic en el primer vértice
      if (this.polygonCoords.length > 2 && this.isPointCloseToVertex(latLng)) {
        this.isClosed = true;
        this.resetCursor();
        this.stateSelectView = true;
        this.statusSelect = true;
        this.polygonCoordsStatic = [];
        this.zonaOptions[0].state = true;
        this.zonaOptions[1].state = true;
        this.zonaOptions[2].state = true;
        this.zonaOptions[3].state = true;
        this.zonaOptions[4].state = true;
        // Aquí puedes realizar cualquier acción adicional con las coordenadas actualizadas
        const polygon = new google.maps.Polygon({
          paths: this.polygonCoords.map(point => ({ lat: point.lat, lng: point.lng })),
        });
        let arrayTotal = [];
        Object.entries(this.markerGroups).forEach(([clinicName, clinicData]) => {
          // Filtrar los marcadores dentro del polígono y con state = true
          const markersInsidePolygon = clinicData.items.filter(marker => {
            const markerPosition = new google.maps.LatLng(marker.latitud, marker.longitud);

            // Verificar si el marcador está dentro del polígono y su estado es true
            return google.maps.geometry.poly.containsLocation(markerPosition, polygon) && marker.state === true;
          });
          console.log("array datos", markersInsidePolygon);
          // Llamar a la función guardarDatos con los marcadores dentro del polígono y con state = true
          arrayTotal = [...arrayTotal, ...markersInsidePolygon];
        });
        this.guardarDatos(arrayTotal);

      }
      // Limpiar el vértice temporal después de agregar
      this.tempVertex = null;
      // Limpiar el vértice
    },
    isPointCloseToVertex(latLng) {
      const threshold = 0.0500; // Umbral para cerrar el polígono
      const firstVertex = this.polygonCoords[0];
      return (
        Math.abs(latLng.lat() - firstVertex.lat) < threshold &&
        Math.abs(latLng.lng() - firstVertex.lng) < threshold
      );
    },
    updetaZonaView(item, index) {
      this.zonaOptions[index].state = !item.state;
    },
    // Método para generar el color del icono del grupo seleccionado
    getGroupColor(groupIndex) {
      // Si el grupo es el seleccionado, usamos el color actualizado
      return groupIndex === this.selectedGroupIndex ? this.selectedColor.hex : this.markerGroups[groupIndex].color;
    },
    getGroupColorClinica(groupIndex) {
      // Si el grupo es el seleccionado, usamos el color actualizado
      return groupIndex === this.selectedGroupIndexClinica ? this.selectedColor.hex : this.markerGroups[groupIndex].color;
    },
    // Método para obtener las opciones de cada marcador, incluyendo el color
    getMarkerOptions(groupIndex) {
      const color = this.getGroupColor(groupIndex);
      return {
        url: this.createCustomIcon(color),
        scaledSize: { width: 10, height: 10, f: 'px', b: 'px', }   // Creamos el icono con el color del grupo
      };
    },
    // Método para obtener las opciones de cada marcador, incluyendo el color
    getMarkerOptionsClinica(groupIndex) {
      const color = this.getGroupColorClinica(groupIndex);
      return {
        url: this.createClinicaIcon(color),
        scaledSize: { width: 25, height: 25, f: 'px', b: 'px', }   // Creamos el icono con el color del grupo
      };
    },
    getScaledSize() {
      // Cambia el tamaño del icono según el nivel de zoom (ajusta los valores según sea necesario)
      const baseSize = 9; // Tamaño base
      const scaleFactor = 1 + (this.zoom / 150); // Factor de escala
      return {
        width: baseSize * scaleFactor,
        height: baseSize * scaleFactor
      };
    },
    getScaledSizeClinica() {
      // Cambia el tamaño del icono según el nivel de zoom (ajusta los valores según sea necesario)
      const baseSize = 100; // Tamaño base
      const scaleFactor = 1 + (this.zoom / 10); // Factor de escala
      return {
        width: baseSize * scaleFactor,
        height: baseSize * scaleFactor
      };
    },
    toggleColorPicker(item, event) {
      if (this.selectedItem === item) {
        this.isColorPickerVisible = !this.isColorPickerVisible;
      } else {
        this.selectedColor.hex = this.markerGroups[item.name].color;
        this.selectedItem = item;
        this.isColorPickerVisible = true;
        this.selectedGroupIndex = item.name;
        this.selectedGroupIndexClinica = item.name;
      }
    },
    showInfoWindow(marker, index) {
      this.infoWindowPosition = {
        lat: parseFloat(marker.latitud),
        lng: parseFloat(marker.longitud)
      };
      this.infoWindowContent = `<div class="text-negra"><b>${marker.paciente}</b></div><br><div class="text-content"><b>DNI:</b> ${marker.num_doc}<br/><b>Clínica:</b> ${marker.descripcas}</div>`;
      this.infoWindowOpened = true;
    },
    showInfoWindowClinica(marker, index) {
      this.infoWindowPositionClinica = {
        lat: parseFloat(marker.latitud),
        lng: parseFloat(marker.longitud)
      };
      this.infoWindowContentClinica = `<div class="text-negra"><b>${marker.name}</b></div><br><div class="text-content"><b>Cupos totales:</b> ${marker.num_totales}<br><b>Cupos disponibles:</b>  ${marker.num_liberado}<br><b>Cupos asignado:</b> ${marker.num_asignado}</div>`;
      this.infoWindowOpenedClinica = true;
    },
    showInfoWindowClinicaOpa(marker, index) {
      this.infoWindowPositionClinica = {
        lat: parseFloat(marker.latitud),
        lng: parseFloat(marker.longitud)
      };
      this.infoWindowContentClinica = `<div class="text-negra"><b>${marker.nombreClinica}</b></div><br><div class="text-content"><b>Cupos totales:</b> ${marker.num_totales}<br><b>Cupos disponibles:</b>  ${marker.num_liberado}<br><b>Cupos asignado:</b> ${marker.num_asignado}</div>`;
      this.infoWindowOpenedClinica = true;
    },
    ...mapActions(['guardarDatos']),
    onPolygonPathsChanged1(event) {
      if (event.Fg[0]) {
        console.log
        this.listPath = event.Fg[0].Fg
      } else if (event.Eg[0]) {
        this.listPath = event.Eg[0].Eg
      } else if (event.Gg[0]) {
        this.listPath = event.Gg[0].Gg
      } else if (event.Ig[0]) {
        this.listPath = event.Ig[0].Ig
      }
      // Obtener las coordenadas actualizadas del polígono
      const newPaths = this.listPath.map(point => ({
        lat: point.lat(),
        lng: point.lng()
      }));

      // Aquí puedes realizar cualquier acción adicional con las coordenadas actualizadas
      const polygon = new google.maps.Polygon({
        paths: newPaths.map(point => ({ lat: point.lat, lng: point.lng })),
      });
      let arrayTotal = [];
      Object.entries(this.markerGroups).forEach(([clinicName, clinicData]) => {
        // Filtrar los marcadores dentro del polígono y con state = true
        const markersInsidePolygon = clinicData.items.filter(marker => {
          const markerPosition = new google.maps.LatLng(marker.latitud, marker.longitud);

          // Verificar si el marcador está dentro del polígono y su estado es true
          return google.maps.geometry.poly.containsLocation(markerPosition, polygon) && marker.state === true;
        });
        console.log("array datos", markersInsidePolygon);
        // Llamar a la función guardarDatos con los marcadores dentro del polígono y con state = true
        arrayTotal = [...arrayTotal, ...markersInsidePolygon];
      });
      this.guardarDatos(arrayTotal);
    },
    onMarkerDragEnd(index, event) {
      // Obtiene las nuevas coordenadas del marcador
      const newLat = event.latLng.lat();
      const newLng = event.latLng.lng();

      // Actualiza las coordenadas del marcador en la lista
      this.marcadores[index].posicion = { lat: newLat, lng: newLng };
    },
    generateGroupedDataArray() {
      const groupedDataArray = Object.keys(this.arrayDataClinica)
        .filter((key) => this.arrayDataClinica[key].nombreClinica)
        .map((key) => {
          const clinicName = this.arrayDataClinica[key].nombreClinica;
          const frequencies = this.arrayFrecuenciaClinica[clinicName];

          // Filtrar solo las frecuencias con state: true
          const groupFilter = frequencies
            .filter(frequency => frequency.state)
            .map(frequency => ({
              name: frequency.name,
              state: frequency.state,
            }));

          return {
            index: key,
            name: clinicName,
            latitud: this.arrayDataClinica[key].latitud,
            longitud: this.arrayDataClinica[key].longitud,
            num_asignado: this.arrayDataClinica[key].num_asignado,
            num_liberado: this.arrayDataClinica[key].num_liberado,
            num_totales: this.arrayDataClinica[key].num_totales,
            color: "#FFFF",
            groupFilter: groupFilter, // Solo incluir frecuencias con state: true
          }
        });
      this.arrayClinicasMapa = groupedDataArray;
    },
  },
  mounted() {
    this.$refs.customControl && this.$refs.customControl.classList.add("custom-map-control");
  },
  computed: {
    ...mapGetters(['arrayData']),
    ...mapGetters(['arrayDataClinica']),
    ...mapGetters(['arrayDataClinicaTotal']),
    createCustomIcon() {
      return (color) => {
        const size = this.getScaledSize();
        const encodedColor = encodeURIComponent(color); // Codifica el color para ser seguro en la URL
        return `data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="${encodedColor}" stroke="${encodedColor}" fill-opacity="1" stroke-opacity="1" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle></svg>`;
      };
    },
    createClinicaIcon() {
      return (color) => {
        const size = this.getScaledSizeClinica();
        const encodedColor = encodeURIComponent(color); // Codifica el color para ser seguro en la URL
        return `data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 24 24" fill="${encodedColor}" stroke="${encodedColor}" fill-opacity="1" stroke-opacity="1" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
        <!-- Edificio del hospital -->
        <rect x="4" y="6" width="16" height="12" fill="${encodedColor}" />
        <!-- Cruz del hospital -->
        <rect x="10" y="4" width="4" height="16" fill="white" />
        <rect x="4" y="10" width="16" height="4" fill="white" />
        <!-- Puertas -->
        <rect x="9" y="14" width="2" height="4" fill="white" />
        <rect x="13" y="14" width="2" height="4" fill="white" />
        <!-- Ventanas -->
        <rect x="5" y="7" width="3" height="3" fill="white" />
        <rect x="16" y="7" width="3" height="3" fill="white" />
        </svg>`
      };
    }
  },
  watch: {
    // Cuando cambie el color seleccionado, actualizamos el color del grupo seleccionado
    selectedColor(newColor) {
      // Cambiar el color del grupo seleccionado
      this.markerGroups[this.selectedGroupIndex].color = newColor.hex;
    },
    arrayData(newValue, oldValue) {
      let groupIndex = 0;
      const groupFrecuenciaClinica = [];
      const groupedData = this.arrayData.reduce((acc, item) => {
        if (item.descripcas === null) {
          return acc; // Saltar los elementos donde descripcas es null
        }
        if (!acc[item.descripcas]) {
          acc[item.descripcas] = {
            code: groupIndex++,
            items: [],
            color: "#C70F03",
          };
          // Inicializar las frecuencias para la clínica en `false`
          groupFrecuenciaClinica[item.descripcas] = [
            { name: "LUN-MIE-VIE", state: false },
            { name: "MAR-JUE-SAB", state: false },
            { name: "LUN-VIE", state: false },
            { name: "MAR-SAB", state: false }
          ];
        }

        // Agregar el campo `state: true` dentro de cada `item`
        acc[item.descripcas].items.push({
          ...item,  // Mantener las propiedades originales del item
          state: true  // Agregar el campo `state: true`
        });
        // Actualizar el estado de las frecuencias para la clínica
        const clinicFrequencies = groupFrecuenciaClinica[item.descripcas];
        clinicFrequencies.forEach((frequency) => {
          if (frequency.name === item.frecuencia) {
            frequency.state = true;
          }
        });
        return acc;
      }, {});
      this.markerGroups = groupedData;
      this.markerGroupsPermanente = groupedData;
      this.arrayFrecuenciaClinica = groupFrecuenciaClinica;
      // Llamada correcta
      if (typeof this.generateGroupedDataArray === "function") {
        this.generateGroupedDataArray();
      } else {
        console.error("generateGroupedDataArray no está definida.");
      }
    },
  },
  created() {
    this.marcadores = this.dataPaciente;
  },
  components: {
    GmapMapa,
    ChromePicker: Chrome
  },
};
</script>